module.exports = __webpack_public_path__ + "img/04.3bbac2b9.png";